import React, { FC } from 'react';
import TelescopeIcon from '../../images/telescope.svg'
import { Link } from "react-router-dom";
import { ButtonTypes } from "../../models/ButtonTypes";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import { useSelector } from 'react-redux';
import { RouterRootState } from 'connected-react-router';
import Restricted from '../../contexts/PermissionProvider/RestrictedWrapper';

interface Props {
    setShowModal?: any,
    rowPath?: string,
    hideAddNewButton?: boolean,
    addNewButton?: any
    message?: string
}
const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}

const EmptyTableState: FC<Props> = ({ setShowModal, rowPath, hideAddNewButton, addNewButton, message }) => {
    const { translate } = useLocale();
    const routeName = useSelector((state: RouterRootState) => getRouteNameFromPath(state.router.location.pathname));
    const onShowModal = (e) => {
        e.preventDefault()
        setShowModal(true)
    }
    return <div className=" flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
            <div>
                <img
                    className="mx-auto w-auto"
                    src={TelescopeIcon}
                    alt="telescope"
                />
                <h2 className="mt-6 text-center text-xl font-extrabold text-gray-700">{message ?? translate.byKey(TranslationKeys.noRecordsfound)}</h2>
                {addNewButton ? <div className="mt-4 text-center"> {addNewButton}</div> : hideAddNewButton ? null : <div className="mt-4 text-center">
                    {setShowModal ? <Restricted to={`add.${routeName}.element`}>
                        <button onClick={onShowModal} className={ButtonTypes.BlueButton}>
                            {translate.byKey(TranslationKeys.addNew)}
                        </button>
                    </Restricted> : null}
                    {!setShowModal && rowPath ?
                        <Restricted to={`add.${routeName}.element`}>
                            <Link to={rowPath}>   <button className={ButtonTypes.BlueButton}>
                                {translate.byKey(TranslationKeys.addNew)}
                            </button></Link>
                        </Restricted> : null}

                </div>}

            </div>

        </div>
    </div>
};

export default EmptyTableState;
